"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { WvcLogo } from "@/integrations/wordpress/WvcLogo";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { Facebook, Twitter, Instagram, Youtube, Mail, Phone, MapPin } from "lucide-react";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <ul className="space-y-3">
        {[1, 2, 3, 4].map((_, i) => <li key={i} data-index={i}>
            <div className="h-4 w-24 bg-muted animate-pulse rounded-md" />
          </li>)}
      </ul>;
  }
  if (!menuItems || menuItems.length === 0) {
    return <ul className="space-y-3">
        <li data-index={0}>
          <Link to="/HomePage" className="text-muted-foreground hover:text-primary transition-colors">Home</Link>
        </li>
        <li data-index={1}>
          <Link to="/ContactPage" className="text-muted-foreground hover:text-primary transition-colors">Contact</Link>
        </li>
      </ul>;
  }
  return <ul className="space-y-3">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-muted-foreground hover:text-primary transition-colors">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
const socialLinks = [{
  icon: Facebook,
  href: "#",
  label: "Facebook"
}, {
  icon: Twitter,
  href: "#",
  label: "Twitter"
}, {
  icon: Instagram,
  href: "#",
  label: "Instagram"
}, {
  icon: Youtube,
  href: "#",
  label: "Youtube"
}];
const careGuides = [{
  label: "Vaccinations",
  path: "/ServicesPage"
}, {
  label: "Surgical Care",
  path: "/ServicesPage"
}, {
  label: "Emergency Services",
  path: "/ServicesPage"
}];
export default function Footer() {
  return <section data-section-id="264936" id="footer" className="bg-background border-t border-border pt-16 pb-8 text-sm font-default text-foreground">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-8">
          
          {}
          <div className="flex flex-col items-start">
            <Link to="/" className="mb-6 inline-block">
              <WvcLogo className="h-8 w-auto" />
            </Link>
            <p className="text-muted-foreground mb-6 leading-relaxed">
              Happy Paws Animal Hospital provides compassionate, high-quality veterinary care for your beloved pets. From routine checkups to advanced surgery, we treat every animal like family.
            </p>
            <div className="flex gap-4">
              {socialLinks.map((social, i) => {
              const Icon = social.icon;
              return <Link key={i} to={social.href} aria-label={social.label} className="text-muted-foreground hover:text-primary transition-all duration-300 hover:scale-110" data-index={i}>
                    <Icon className="size-5" />
                  </Link>;
            })}
            </div>
          </div>

          {}
          <div>
            <h3 className="font-default font-semibold text-base mb-6 text-foreground">Quick Links</h3>
            <MenuProvider menu_id="43">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          {}
          <div>
            <h3 className="font-default font-semibold text-base mb-6 text-foreground">Our Services</h3>
            <ul className="space-y-3">
              {careGuides.map((guide, i) => <li key={i} data-index={i}>
                  <Link to={guide.path} className="text-muted-foreground hover:text-primary transition-colors">
                    {guide.label}
                  </Link>
                </li>)}
            </ul>
          </div>

          {}
          <div>
            <h3 className="font-default font-semibold text-base mb-6 text-foreground">Contact Us</h3>
            <ul className="space-y-4 mb-8">
              <li className="flex items-start gap-3 text-muted-foreground" data-index={0}>
                <MapPin className="size-4 mt-0.5 shrink-0" />
                <span>456 Pet Haven Way, Paws City, PC 12345</span>
              </li>
              <li className="flex items-center gap-3 text-muted-foreground" data-index={1}>
                <Phone className="size-4 shrink-0" />
                <span>(555) 987-6543</span>
              </li>
              <li className="flex items-center gap-3 text-muted-foreground" data-index={2}>
                <Mail className="size-4 shrink-0" />
                <span>hello@happypawsclinic.com</span>
              </li>
            </ul>
            
            <h3 className="font-default font-semibold text-base mb-4 text-foreground">Legal</h3>
            <ul className="space-y-3 flex flex-col">
              <li data-index={0}>
                <Link to="#" className="text-muted-foreground hover:text-primary transition-colors">Privacy Policy</Link>
              </li>
              <li data-index={1}>
                <Link to="#" className="text-muted-foreground hover:text-primary transition-colors">Terms of Service</Link>
              </li>
            </ul>
          </div>

        </div>

        {}
        <div className="mt-16 pt-8 border-t border-border flex flex-col md:flex-row justify-between items-center gap-4 text-muted-foreground">
          <p>© {new Date().getFullYear()} Happy Paws Animal Hospital. All rights reserved.</p>
          <p className="text-xs">Providing gentle care for your furry family members.</p>
        </div>
      </div>
    </section>;
}